"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const feedback_entity_1 = require("./feedback.entity");
const notifications_service_1 = require("../notifications/notifications.service");
const notification_log_entity_1 = require("../notifications/notification-log.entity");
let FeedbackService = class FeedbackService {
    constructor(feedbackRepo, notificationsService) {
        this.feedbackRepo = feedbackRepo;
        this.notificationsService = notificationsService;
    }
    findAll(customerId) {
        const where = {};
        if (customerId)
            where.customer = { id: customerId };
        return this.feedbackRepo.find({
            where,
            relations: ['customer', 'collectedBy', 'relatedOrder'],
            order: { createdAt: 'DESC' },
        });
    }
    async findById(id) {
        const feedback = await this.feedbackRepo.findOne({
            where: { id },
            relations: ['customer', 'collectedBy', 'relatedOrder'],
        });
        if (!feedback)
            throw new common_1.NotFoundException(`Feedback #${id} not found`);
        return feedback;
    }
    create(dto) {
        const feedback = this.feedbackRepo.create({
            customer: { id: dto.customerId },
            relatedOrder: dto.orderId ? { id: dto.orderId } : undefined,
            collectedBy: { id: dto.collectedById },
            status: feedback_entity_1.FeedbackStatus.PENDING_FORM,
        });
        return this.feedbackRepo.save(feedback);
    }
    async sendForm(feedbackId, phone) {
        const feedback = await this.findById(feedbackId);
        await this.notificationsService.send({
            customerId: feedback.customer.id,
            toPhone: phone,
            template: notification_log_entity_1.NotificationTemplate.FEEDBACK_FORM,
            relatedEntityId: feedbackId,
            relatedEntityType: 'feedback',
        });
        feedback.status = feedback_entity_1.FeedbackStatus.FORM_SENT;
        feedback.formSentAt = new Date();
        return this.feedbackRepo.save(feedback);
    }
    async markFormFilled(id, sentiment, feedbackText, rating) {
        const feedback = await this.findById(id);
        feedback.sentiment = sentiment;
        feedback.feedbackText = feedbackText;
        feedback.rating = rating;
        feedback.formFilledAt = new Date();
        if (sentiment === feedback_entity_1.FeedbackSentiment.POSITIVE) {
            feedback.status = feedback_entity_1.FeedbackStatus.VIDEO_REQUESTED;
            feedback.videoRequestedAt = new Date();
            // auto send VIDEO_REVIEW_REQUEST — phone not available here, log intent
            // In a full implementation, customer phone would be fetched via customer relation.
        }
        else if (sentiment === feedback_entity_1.FeedbackSentiment.NEGATIVE) {
            feedback.status = feedback_entity_1.FeedbackStatus.ESCALATED_MGMT;
        }
        else {
            feedback.status = feedback_entity_1.FeedbackStatus.FORM_FILLED;
        }
        return this.feedbackRepo.save(feedback);
    }
    async sendFollowUp(id, phone) {
        const feedback = await this.findById(id);
        await this.notificationsService.send({
            customerId: feedback.customer.id,
            toPhone: phone,
            template: notification_log_entity_1.NotificationTemplate.FEEDBACK_FOLLOWUP,
            relatedEntityId: id,
            relatedEntityType: 'feedback',
        });
        feedback.status = feedback_entity_1.FeedbackStatus.FOLLOW_UP_SENT;
        feedback.followUpSentAt = new Date();
        return this.feedbackRepo.save(feedback);
    }
    async addManagementRemarks(id, remarks) {
        const feedback = await this.findById(id);
        feedback.managementRemarks = remarks;
        return this.feedbackRepo.save(feedback);
    }
    async close(id, finalRemarks) {
        const feedback = await this.findById(id);
        feedback.status = feedback_entity_1.FeedbackStatus.CLOSED;
        feedback.finalRemarks = finalRemarks;
        return this.feedbackRepo.save(feedback);
    }
};
exports.FeedbackService = FeedbackService;
exports.FeedbackService = FeedbackService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(feedback_entity_1.Feedback)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof notifications_service_1.NotificationsService !== "undefined" && notifications_service_1.NotificationsService) === "function" ? _b : Object])
], FeedbackService);
